import { useCallback, useEffect, useRef, useState } from "react";

export interface UseErrorBoundaryPathResetReturn {
	key: number;
	onError: () => void;
	onReset: () => void;
	resetAfterError: () => void;
}

const useErrorBoundaryPathReset = (path: string): UseErrorBoundaryPathResetReturn => {
	const [key, setKey] = useState(0);
	const errorPathRef = useRef<string | null>(null);
	const resetAfterError = useCallback(() => {
		if (errorPathRef.current === null) return;
		errorPathRef.current = null;
		setKey((count) => count + 1);
	}, []);
	useEffect(() => {
		if (errorPathRef.current !== path) resetAfterError();
	}, [path, resetAfterError]);

	return {
		key,
		onError: () => {
			errorPathRef.current = path;
		},
		onReset: () => {
			errorPathRef.current = null;
		},
		resetAfterError
	};
};

export default useErrorBoundaryPathReset;
